module.exports = __webpack_public_path__ + "img/ariel-view-floor-space.f675dc62.jpg";